export const getThemeAndSizeClasses = ({
    theme,
    size,
    isUrgentStateAndNotWon
}: {
    theme: string;
    size?: string;
    isUrgentStateAndNotWon: boolean;
}) => {
    let classNames = 'jackpot-amount-time ';

    if (!isUrgentStateAndNotWon && theme) {
        classNames += `jackpot-amount-time__${theme} `;
    }

    if (size === 'S') {
        classNames += 'jackpot-amount-time__small ';
    }

    return classNames;
};
